import { useEffect, useRef, useState } from 'react';
import { register, call } from './funcStore';
import { mockVtubers } from './data/mockVtubers';
import { mockLiveStreams } from './data/mockLiveStreams';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import VTuberDetailPage from './pages/VTuberDetailPage';
import { getVtuberById, getTrendingVideos } from './api/mockApi';
import { logAction } from './api/logApi';

const SCREEN_BEFORE_INIT = 'beforeInit';
const SCREEN_HOME = 'home';
const SCREEN_SEARCH = 'search';
const SCREEN_DETAIL = 'detail';

function App() {
  const [screenId, setScreenId] = useState(SCREEN_BEFORE_INIT);

  const screenIdRef = useRef(screenId);
  screenIdRef.current = screenId;

  const dataRef = useRef({
    selectedVtuberId: null,
    history: [],
    homeClickedTag:""
  });

  const pushHistory = (newScreenId) => {
    const entry = {
      screenId: newScreenId,
      selectedVtuberId: dataRef.current.selectedVtuberId,
    };

    dataRef.current.history.push(entry);

    const index = dataRef.current.history.length - 1;
    window.history.pushState({ index }, '');
  };

  const handlePopState = (event) => {
    const index = event.state ? event.state.index : null;

    if (index === null || index === undefined) {
      return;
    }

    const entry = dataRef.current.history[index];

    if (!entry) {
      return;
    }

    dataRef.current.selectedVtuberId = entry.selectedVtuberId;
    setScreenId(entry.screenId);
  };

  const init = () => {
    register('app.navigateToHome', () => {
      logAction('navigate_home');
      pushHistory(SCREEN_HOME);
      setScreenId(SCREEN_HOME);
    });

    register('app.navigateToSearch', () => {
      logAction('navigate_search');
      pushHistory(SCREEN_SEARCH);
      setScreenId(SCREEN_SEARCH);
    });

    register('app.navigateToDetail', (vtuberId) => {
      logAction('navigate_detail', { vtuberId });
      dataRef.current.selectedVtuberId = vtuberId;
      pushHistory(SCREEN_DETAIL);
      setScreenId(SCREEN_DETAIL);
    });

    register('app.searchByTag', (tag) => {
      logAction('tag_click', { tag });

      if (screenIdRef.current === SCREEN_HOME) {
        dataRef.current.homeClickedTag = tag
      }
      if (screenIdRef.current === SCREEN_SEARCH) {
        call('searchPage.setFilterByTag', tag);
        call('searchPage.submit');
        return;
      }

      pushHistory(SCREEN_SEARCH);
      setScreenId(SCREEN_SEARCH);
    });

    register('app.getClickedTag',()=>{
      const tag = dataRef.current.homeClickedTag
      dataRef.current.homeClickedTag = ""
      return tag
    })

    register('app.getSelectedVtuberId', getSelectVtuberId);

    register('app.getVtuberById', async(id) =>
      await getVtuberById(id)
    );

    register('app.getLiveStreamById', (id) =>
      mockLiveStreams.find((stream) => stream.id === id)
    );

    register('app.getTrendingVideos', (range) => getTrendingVideos(range));

    window.addEventListener('popstate', handlePopState);

    dataRef.current.history.push({
      screenId: SCREEN_HOME,
      selectedVtuberId: null,
    });
    window.history.replaceState({ index: 0 }, '');

    setScreenId(SCREEN_HOME);
  };

  const getSelectVtuberId=()=>{
    return dataRef.current.selectedVtuberId
  }

  useEffect(() => {
    if (screenId === SCREEN_BEFORE_INIT) {
      init();
    }
  }, [screenId]);

  useEffect(() => {
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  if (screenId === SCREEN_BEFORE_INIT) {
    return null;
  }

  if (screenId === SCREEN_DETAIL) {
    return <VTuberDetailPage />;
  }

  if (screenId === SCREEN_SEARCH) {
    return <SearchPage />;
  }

  return <HomePage />;
}

export default App;
